import moment from 'moment';

import { DATE_TIME_FORMAT } from '../../constants/shared';

const parseDateTimeFormat = (value) => moment(value)
  .utcOffset(180)
  .format(DATE_TIME_FORMAT);

export default parseDateTimeFormat;
